import styled from "styled-components";
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import { StyledButton } from "components/Buttons/DefaultButton/DefaultButton.styles";


export const TitleContainer = styled.div`
  padding: 1.5rem;
  border-radius: 16px;
  background-color: var(--background-success, #F1F7FF);
  display: flex;
  flex-direction: column;
  align-items: start;
  
  @media(min-width: 768px) {
    padding: 2rem;
  }
`

export const Title = styled.div`
  margin-bottom: 12px;
  font-size: 1.5rem;
  line-height: 1.3;
  color: #000;
  font-weight: 600;
  
  @media(min-width: 768px) {
    font-size: 1.75rem;
  }
`

export const Subtitle = styled.div`
  margin-bottom: 8px;
  font-size: 1rem;
  line-height: 1.3;
  color: #000;
  font-weight: 500;
`

export const SubtitleSecondary = styled(Subtitle)`
  font-size: 0.9rem;
  line-height: 1.3;
  font-weight: 400;
  color: #000;
  opacity: 60%;
`

export const JobTitleButton = styled(StyledButton)`
  max-width: 10rem;
  max-height: 2.5rem;
  margin-top: 1rem;
  font-size: var(--typography-body2-size, 0.875rem) !important;
`
 
export const MenuOutlinedIconStyled = styled(MenuOutlinedIcon)`
  color: var(--primary-blue, #0B4598);
  font-size: var(--typography-body2-size, 0.875rem) !important;
  padding-right: 0.5rem;

`